import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { images } from '../../data/content';

const credentials = {
  en: [
    'Positive Psychologist',
    'Emotional Intelligence Specialist',
    'Certified Crystal Healer',
  ],
  ar: [
    'عالمة نفس إيجابية',
    'أخصائية ذكاء عاطفي',
    'معالجة احجار كريمة معتمدة',
  ],
};

const CredibilityStrip = () => {
  const { isRTL } = useLanguage();
  const pills = isRTL ? credentials.ar : credentials.en;

  return (
    <div className="bg-charcoal-100 border-y border-gold/10 py-4 sm:py-5">
      <div className="container mx-auto px-4 sm:px-6 lg:px-10">
        <div
          className={`flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5 ${
            isRTL ? 'sm:flex-row-reverse' : ''
          }`}
        >
          {/* Portrait + Name */}
          <div
            className={`flex items-center gap-3 ${
              isRTL ? 'flex-row-reverse' : ''
            }`}
          >
            <img
              src={images.about.portrait}
              alt="Mona Bizzari"
              className="w-10 h-10 rounded-full object-cover object-top border border-gold/30 flex-shrink-0"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <span className="font-serif text-gold text-base sm:text-lg tracking-wide whitespace-nowrap">
              Mona Bizzari
            </span>
          </div>

          {/* Divider — hidden on mobile */}
          <span className="hidden sm:block text-white/20 text-lg select-none">·</span>

          {/* Credential Pills */}
          <div
            className={`flex flex-wrap items-center justify-center gap-2 ${
              isRTL ? 'flex-row-reverse' : ''
            }`}
          >
            {pills.map((pill, i) => (
              <React.Fragment key={pill}>
                <span className="text-cream-300 text-xs sm:text-sm tracking-wide whitespace-nowrap px-3 py-1 rounded-full border border-gold/20 bg-gold/5 hover:border-gold/40 transition-colors duration-200">
                  {pill}
                </span>
                {i < pills.length - 1 && (
                  <span className="hidden sm:inline text-white/20 text-xs select-none">·</span>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CredibilityStrip;
